import { Seat, Room, KonvaRoom, KonvaSeat } from "../types";

export function transformToKonvaRooms(rooms: Room[], seats: Seat[]): Record<string, KonvaRoom[]> {
    const result: Record<string, KonvaRoom[]> = {};

    rooms.forEach((room) => {
        const roomSeats: KonvaSeat[] = seats
            .filter((seat) => seat.room.name === room.name)
            .map((seat) => ({
                id: seat.id,
                x: seat.xCoordinate,
                y: seat.yCoordinate,
                label: seat.name,
                orientation: seat.orientation
            }));
        const KonvaRoom: KonvaRoom = {
            name: room.name,
            id: room.id,
            floor: room.floorPlan.name,
            department: room.description,
            x: room.xCoordinate,
            y: room.yCoordinate,
            width: room.width,
            height: room.height,
            borderColor: room.borderColor || "#FF0000",
            seats: roomSeats
        };
        if (!result[room.floorPlan.id]) {
            result[room.floorPlan.id] = [];
        }
        result[room.floorPlan.id].push(KonvaRoom);
    });
    return result;
}
